import { Pipe, PipeTransform } from '@angular/core';

import { SideMenuNestedItemHighlightViewModelEnum } from './side-menu-nested-item.view-model';

@Pipe({
  name: 'sideMenuNestedItemForcedHighlight',
})
export class SideMenuNestedItemForcedHighlightPipe implements PipeTransform {
  public transform(forcedHighlight: SideMenuNestedItemHighlightViewModelEnum | undefined): boolean | undefined {
    if (forcedHighlight === undefined) return;
    return {
      [SideMenuNestedItemHighlightViewModelEnum.Highlight]: true,
      [SideMenuNestedItemHighlightViewModelEnum.NoHighlight]: false,
    }[forcedHighlight];
  }
}
